<dx-number-box [ngClass]="cssClass" [id]="cssId" [format]="!!format ? format : ''"
  placeholder="{{ placeholder }}" [max]="max!" [min]="min!" [disabled]="disabled"
  (onFocusIn)="selectAllInputText($event)"
  (onKeyDown)="keyDown($event)"
  [showSpinButtons]="showSpinButtons" (valueChange)="valueChanged($event)" [(value)]="value!" [showClearButton]="showClearButton"
  [valueChangeEvent]="triggerChangeOnKeyUp ? 'keyup blur' : 'change'">
  <dx-validator [validationGroup]="validationGroupName">
    <dxi-validation-rule *ngIf="required"
      type="required" [message]="requiredMessage ?? 'Field is required'">
    </dxi-validation-rule>
  </dx-validator>
</dx-number-box>
